// src/components/Header.tsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import AuthModal from './AuthModal';
import { getCurrentUser } from '../services/api';

const Header: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
    const [avatarUrl, setAvatarUrl] = useState<string | null>(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        setIsLoggedIn(!!token);
        if (token) {
            getCurrentUser().then(user => {
                setAvatarUrl(user.avatar_url || null);
            }).catch(() => setAvatarUrl(null));
        } else {
            setAvatarUrl(null);
        }
    }, [location]);

    // 检查是否在登录/注册页面
    const isAuthPage = location.pathname === '/login' || location.pathname === '/register';

    const handleAvatarClick = () => {
        const token = localStorage.getItem('token');
        if (!token) {
            setIsAuthModalOpen(true);
        } else {
            // 已登录，执行登出
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            navigate('/login');
        }
    };

    const handleLoginClick = () => {
        setIsAuthModalOpen(true);
    };

    const handleStartClick = () => {
        setIsAuthModalOpen(true);
    };

    // 如果是登录/注册页面，显示新导航栏
    if (isAuthPage) {
        return (
            <header className="custom-header">
                <div className="header-content">
                    <Link to="/" className="blog-title">
                        Personal Blog
                    </Link>
                    <nav className="nav-menu">
                        <Link to="/about" className="nav-link">我们的故事</Link>
                        <button className="nav-link login-btn" onClick={handleLoginClick}>
                            登录
                        </button>
                        <button className="nav-link start-btn" onClick={handleStartClick}>
                            开始
                        </button>
                    </nav>
                </div>
                <AuthModal
                    isOpen={isAuthModalOpen}
                    onClose={() => setIsAuthModalOpen(false)}
                />
            </header>
        );
    }

    // 登录后的导航栏（原来的样式）
    return (
        <header className="custom-header">
            <Link to="/" className="blog-title main-blog-title">个人博客</Link>
            <nav className="nav-fixed">
                <button className="nav-icon-btn" onClick={() => navigate('/write')}>
                    {/* 写作图标 */}
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginRight: 4 }}>
                        <path d="M3 17h2.586l9.293-9.293a1 1 0 0 0-1.414-1.414L4.172 15.586V17z" fill="currentColor" />
                        <path d="M14.293 6.293a1 1 0 0 1 1.414 1.414l-9.293 9.293H3v-2.586l9.293-9.293z" stroke="currentColor" />
                    </svg>
                    写
                </button>
                <button className="nav-icon-btn">
                    {/* 通知图标（描边铃铛） */}
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10 18a2 2 0 0 0 2-2H8a2 2 0 0 0 2 2z" fill="currentColor" />
                        <path d="M16 14v-5a6 6 0 1 0-12 0v5l-2 2v1h16v-1l-2-2z" stroke="currentColor" strokeWidth="1.5" fill="none" />
                    </svg>
                </button>
                <button className="nav-avatar-btn" onClick={handleAvatarClick}>
                    {isLoggedIn ? (
                        avatarUrl ? (
                            <img src={avatarUrl} alt="头像" style={{ width: 32, height: 32, borderRadius: '50%' }} />
                        ) : (
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                                <circle cx="11" cy="11" r="10" fill="#1a8917" />
                                <path d="M11 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 2c-2.33 0-7 1.17-7 3.5V18h14v-1.5C18 14.17 13.33 13 11 13z" fill="#fff" />
                            </svg>
                        )
                    ) : (
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                            <circle cx="11" cy="11" r="10" fill="#eee" />
                            <path d="M11 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 2c-2.33 0-7 1.17-7 3.5V18h14v-1.5C18 14.17 13.33 13 11 13z" fill="#bbb" />
                        </svg>
                    )}
                </button>
            </nav>
            <AuthModal
                isOpen={isAuthModalOpen}
                onClose={() => setIsAuthModalOpen(false)}
            />
        </header>
    );
};

export default Header;